import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API from "./config/API";

function BedMaxCountForm() {
  const [formData, setFormData] = useState([]);
  const [popup, setPopup] = useState("");
  const [allMaxBedsCount, setAllMaxBedsCount] = useState("");

  const navigate = useNavigate();

  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const emailId = loggedUser?.emailId || "";

  useEffect(() => {
    if (emailId) {
      fetchRooms();
    } else {
      showPopup("User not logged in");
    }
  }, [emailId]);

  // ================= FLOOR COLORS =================

  const getFloorColor = (floorName) => {
    const colors = {
      "Floor-1": "#dbeafe",
      "Floor-2": "#dcfce7",
      "Floor-3": "#fef3c7",
      "Floor-4": "#fee2e2",
      "Floor-5": "#ede9fe",
    };

    return colors[floorName] || "#f8fafc";
  };

  // ================= FETCH ROOMS =================

  const fetchRooms = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const res = await axios.get(
        `${API.V1}/maxLimit/getFloorRoomDetails?emailId=${emailId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data.statusCode === 200) {
        const rooms = res.data.data.roomList || [];

        setFormData(
          rooms.map((room) => ({
            ...room,
            maxBedsCount: room.maxBedsCount || "",
          })),
        );
      } else {
        showPopup(res.data.message || "No rooms found");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert("Session Expired. Please login again.");

        localStorage.clear();

        navigate("/");

        return;
      }

      showPopup("500 : Server down");
    }
  };

  // ================= INPUT CHANGE =================

  const handleChange = (index, value) => {
    const updated = [...formData];

    updated[index].maxBedsCount = value;

    setFormData(updated);
  };

  // ================= SET MAX BEDS TO ALL ROOMS =================

  const handleSetAllBeds = () => {
    if (!allMaxBedsCount) {
      showPopup("Please enter max beds count");

      return;
    }

    const count = Number(allMaxBedsCount);

    if (count <= 0) {
      showPopup("Max beds count must be greater than 0");

      return;
    }

    const updated = formData.map((room) => ({
      ...room,
      maxBedsCount: count,
    }));

    setFormData(updated);

    showPopup(`Max beds count ${count} applied to all rooms`);
  };

  // ================= SUBMIT =================

  const handleSubmit = async () => {
    for (let item of formData) {
      if (!item.maxBedsCount) {
        showPopup(
          `Please enter max beds count for ${item.floorName} - ${item.roomName}`,
        );

        return;
      }

      if (Number(item.maxBedsCount) <= 0) {
        showPopup(
          `Invalid max beds count for ${item.floorName} - ${item.roomName}`,
        );

        return;
      }
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const payload = formData.map((item) => ({
        floorName: item.floorName,
        roomName: item.roomName,
        maxBedsCount: Number(item.maxBedsCount),
        adminEmailId: user?.emailId,
      }));

      const res = await axios.post(
        `${API.V1}/maxLimit/createMaxBedsCount`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data.statusCode === 200) {
        showPopup(res.data.message || "Saved Successfully");

        setTimeout(() => {
          navigate("/configurationSetUpCount");
        }, 1200);
      } else if (res.data.statusCode === 400) {
        showPopup(res.data.message);
      } else {
        showPopup("Failed to save");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert("Session Expired. Please login again.");

        localStorage.clear();

        navigate("/");

        return;
      }

      console.error(error);

      showPopup("500 : Server down, Please try after sometime!");
    }
  };

  // ================= POPUP =================

  const showPopup = (msg) => {
    setPopup(msg);

    setTimeout(() => {
      setPopup("");
    }, 2500);
  };

  return (
    <div style={styles.container}>
      {popup && <div style={styles.popup}>{popup}</div>}

      <div style={styles.card}>
        {/* ================= TITLE ================= */}

        <h2 style={styles.title}>Bed Max Count Setup</h2>

        {/* ================= LOGGED USER ================= */}

        <div style={styles.emailBox}>
          Logged In User : <b>{emailId}</b>
        </div>

        {/* =====================================================
            SET ALL ROOMS MAX BED COUNT
        ===================================================== */}

        <div style={styles.setAllBox}>
          <div style={styles.setAllTitle}>Set Max Bed Count for All Rooms</div>

          <div style={styles.setAllContent}>
            <input
              type="number"
              min="1"
              value={allMaxBedsCount}
              onChange={(e) => setAllMaxBedsCount(e.target.value)}
              placeholder="Enter max beds count"
              style={styles.setAllInput}
            />

            <button
              type="button"
              onClick={handleSetAllBeds}
              style={styles.setAllButton}
            >
              Set to All Rooms
            </button>
          </div>

          <div style={styles.setAllHint}>
            Example: Enter <b>6</b> and click
            <b> Set to All Rooms</b> to set maximum beds as 6 for every room.
          </div>
        </div>

        {/* ================= HEADER ================= */}

        <div style={styles.headerRow}>
          <div>Floor Name</div>

          <div>Room Name</div>

          <div>Max Beds Count</div>
        </div>

        {/* ================= ROOM DATA ================= */}

        {formData.length > 0 ? (
          formData.map((room, index) => (
            <div
              key={index}
              style={{
                ...styles.row,
                background: getFloorColor(room.floorName),
              }}
            >
              {/* FLOOR */}

              <div style={styles.field}>
                <label style={styles.label}>Floor Name</label>

                <input
                  type="text"
                  value={room.floorName}
                  readOnly
                  style={styles.readOnlyInput}
                />
              </div>

              {/* ROOM */}

              <div style={styles.field}>
                <label style={styles.label}>Room Name</label>

                <input
                  type="text"
                  value={room.roomName}
                  readOnly
                  style={styles.readOnlyInput}
                />
              </div>

              {/* MAX BEDS */}

              <div style={styles.field}>
                <label style={styles.label}>Max Beds Count</label>

                <input
                  type="number"
                  min="1"
                  value={room.maxBedsCount}
                  onChange={(e) => handleChange(index, e.target.value)}
                  placeholder="Enter max beds"
                  style={styles.input}
                />
              </div>
            </div>
          ))
        ) : (
          <div style={styles.noData}>No Room Data Available</div>
        )}

        {/* ================= SUBMIT ================= */}

        {formData.length > 0 && (
          <button type="button" style={styles.button} onClick={handleSubmit}>
            Submit All
          </button>
        )}
      </div>
    </div>
  );
}

export default BedMaxCountForm;

/* =========================================================
   STYLES
========================================================= */

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(to right, #dbeafe, #f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    width: "1000px",
    background: "#ffffff",
    padding: "30px",
    borderRadius: "18px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
  },

  title: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#0f172a",
    fontSize: "30px",
    fontWeight: "bold",
  },

  emailBox: {
    background: "#e0f2fe",
    color: "#0369a1",
    padding: "12px",
    borderRadius: "10px",
    marginBottom: "20px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "15px",
  },

  /* ================= SET ALL BOX ================= */

  setAllBox: {
    background: "linear-gradient(to right, #eff6ff, #f0fdf4)",
    border: "1px solid #bfdbfe",
    borderRadius: "14px",
    padding: "20px",
    marginBottom: "22px",
  },

  setAllTitle: {
    color: "#1e3a8a",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "14px",
  },

  setAllContent: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },

  setAllInput: {
    flex: 1,
    padding: "13px",
    borderRadius: "8px",
    border: "1px solid #94a3b8",
    outline: "none",
    fontSize: "15px",
    background: "#ffffff",
  },

  setAllButton: {
    padding: "13px 22px",
    background: "linear-gradient(to right, #2563eb, #1d4ed8)",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "bold",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },

  setAllHint: {
    marginTop: "10px",
    color: "#64748b",
    fontSize: "13px",
  },

  /* ================= HEADER ================= */

  headerRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    background: "#0f172a",
    color: "#ffffff",
    padding: "14px",
    borderRadius: "10px",
    marginBottom: "15px",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "15px",
  },

  /* ================= ROOM ROW ================= */

  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "18px",
    padding: "18px",
    borderRadius: "16px",
    marginBottom: "15px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
    transition: "0.3s",
  },

  field: {
    display: "flex",
    flexDirection: "column",
  },

  label: {
    marginBottom: "8px",
    fontWeight: "bold",
    color: "#1e293b",
    fontSize: "14px",
  },

  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #94a3b8",
    outline: "none",
    fontSize: "15px",
    background: "#ffffff",
  },

  readOnlyInput: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: "15px",
    background: "#ffffff",
    fontWeight: "600",
    color: "#0f172a",
  },

  /* ================= SUBMIT ================= */

  button: {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(to right, #16a34a, #15803d)",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontSize: "17px",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "15px",
  },

  /* ================= POPUP ================= */

  popup: {
    position: "fixed",
    top: "20px",
    right: "20px",
    background: "#111827",
    color: "#ffffff",
    padding: "12px 18px",
    borderRadius: "8px",
    zIndex: 999,
    fontWeight: "bold",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },

  /* ================= NO DATA ================= */

  noData: {
    textAlign: "center",
    padding: "20px",
    color: "#dc2626",
    fontWeight: "bold",
    fontSize: "18px",
  },
};
